import React from 'react';

const values = [
  { title: 'Lever raskt', desc: 'Uker til produksjon, ikke kvartaler.' },
  { title: 'Vær pålitelig', desc: '99.7% oppetid eller vi fikser det gratis.' },
  { title: 'Eie resultatet', desc: 'Vi leverer ikke fra oss. Vi drifter.' },
  { title: 'Hold det enkelt', desc: 'Kompleksitet er fienden til pålitelighet.' },
];

export default function About() {
  return (
    <div className="win95-about-dialog">
      {/* Classic Win95 About Box Header */}
      <div className="win95-about-header">
        <div className="win95-about-logo">
          <div className="win95-flag-about">
            <div className="flag-sq red"></div>
            <div className="flag-sq green"></div>
            <div className="flag-sq blue"></div>
            <div className="flag-sq yellow"></div>
          </div>
        </div>
        <div className="win95-about-title-section">
          <div className="win95-about-name">Autonomous</div>
          <div className="win95-about-version">Versjon 1.0</div>
          <div className="win95-about-copyright">Copyright © 2025 Autonomous AS</div>
          <div className="win95-about-location">Norge</div>
        </div>
      </div>

      <hr className="win95-hr" />

      {/* System Info Style */}
      <div className="win95-about-system">
        <div className="win95-system-label">Dette selskapet er bygget for:</div>
        <div className="win95-system-info">
          Ingeniører som ble lei av å se AI-prosjekter feile.
        </div>
      </div>

      <div className="win95-about-description" data-testid="about-copy">
        <p>
          Ikke feile fordi teknologien ikke fungerte—feile fordi de aldri kom ut av pilotfasen. 
          Død av komité. Død av scope creep. Død av "vi trenger mer data."
        </p>
        <p>
          Så vi bygget et selskap som gjør én ting: få AI i produksjon, og holde det kjørende.
          Ingen konsulenter. Ingen 6-måneders discovery-faser. Bare ingeniører som leverer.
        </p>
      </div>

      <hr className="win95-hr" />

      {/* Values as a GroupBox */}
      <div className="win95-groupbox">
        <div className="win95-groupbox-title">Hvordan Vi Jobber</div>
        <div className="win95-values-list">
          {values.map((v, i) => (
            <div key={i} className="win95-value-row">
              <span className="win95-value-bullet">►</span>
              <span className="win95-value-title">{v.title}</span>
              <span className="win95-value-sep">—</span>
              <span className="win95-value-desc">{v.desc}</span>
            </div>
          ))}
        </div>
      </div>

      {/* OK Button */}
      <div className="win95-about-buttons">
        <button className="win95-btn-ok">OK</button>
      </div>
    </div>
  );
}
